export function ValidateEmail(mail) {
    if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(mail)){
        return (true)
    }else{
        return (false)
    }
}



export function ValidatePhone(phoneNumber) {
    if (/^\d{10}$/.test(phoneNumber)) {
        return true
    } else {
        return false
    }
}

export function ValidateAadhaar(aadhaarNumber) {
    if (/^\d{12}$/.test(aadhaarNumber)) {
        return true
    } else {
        return false
    }
}

export function isLatitude(lat) {
    return isFinite(lat) && Math.abs(lat) <= 90;
  }
  
  export function isLongitude(lng) {
    return isFinite(lng) && Math.abs(lng) <= 180;
  }


// WEBPACK FOOTER //
// ./src/common/ValidationFunctions/CommonValidation.js